import { Tab } from "react-bootstrap";
import { Container, CustomTabs } from "./style";
import { useEffect, useState } from "react";
import { TabAguardandoAprovacao } from "./TabAguardandoAprovacao";
import { TabAprovadosParaPagamento } from "./TabAprovadosParaPagamento";
import usePermissoes from "hooks/usePermissoes";
import { TabReprovados } from "./TabReprovados";
import { ModalCriarLote } from "../ModalCriarLote";
import { ICriarLote } from "../../interface/ICriarLote";
import { CriarLote } from "../CriarLote";

interface IProps {}
export function TabsGerenciarPagamentosFornecedores({}: IProps) {
  const [aba, setAba] = useState<string>("aguardando");
  const [showAbaAguardando, setShowAbaAguardando] = useState<boolean>(false);
  const [showAbaAprovadoParaPagamento, setShowAbaAprovadoParaPagamento] =
    useState<boolean>(false);
  const [showAbaReprovados, setShowAbaReprovados] = useState<boolean>(false);
  const [showModalCriarLote, setShowModalCriarLote] = useState<boolean>(false);
  const defaultCriarLote = {
    tipoLancamento: "C",
    fornecedor: 0,
    numeroNfRecibo: "",
    valorNfRecibo: "",
    arquivo: "",
  };
  const [dadosCriarLote, setDadosCriarLote] =
    useState<ICriarLote>(defaultCriarLote);

  const onSelectAba = (e: string | null) => {
    if (e) {
      setAba(e);
    }
  };

  const { listaPermissoes } = usePermissoes();

  useEffect(() => {
    let abaInicial = "";

    if (!listaPermissoes || !Array.isArray(listaPermissoes)) {
      return;
    }

    if (
      listaPermissoes.some(
        (item) => item.nome_funcionalidade === "guia_pagamentos_reprovados"
      )
    ) {
      setShowAbaReprovados(true);
      abaInicial = "reprovados";
    }

    if (
      listaPermissoes.some(
        (item) => item.nome_funcionalidade === "guia_aprovado_para_pagamento"
      )
    ) {
      setShowAbaAprovadoParaPagamento(true);
      abaInicial = "aprovado";
    }

    if (
      listaPermissoes.some(
        (item) => item.nome_funcionalidade === "guia_aguardando_aprovacao"
      )
    ) {
      setShowAbaAguardando(true);
      abaInicial = "aguardando";
    }

    setAba(abaInicial);
  }, [listaPermissoes]);

  const handleCloseModalCriarLote = () => {
    setShowModalCriarLote(false);
    setDadosCriarLote(defaultCriarLote);
  };

  const onSubmitModalCriarLote = (dados: ICriarLote) => {
    setDadosCriarLote(dados);
    setShowModalCriarLote(false);
    setAba("criarLote");
  };

  return (
    <Container>
      {aba === "criarLote" ? (
        <CriarLote dadosCriarLote={dadosCriarLote} />
      ) : (
        <CustomTabs
          defaultActiveKey={aba}
          activeKey={aba}
          onSelect={onSelectAba}
        >
          {showAbaAguardando && (
            <Tab
              eventKey="aguardando"
              title="Aguardando aprovação"
              style={{ color: "black" }}
            >
              <TabAguardandoAprovacao
                aba={aba}
                setShowModalCriarLote={setShowModalCriarLote}
              />
            </Tab>
          )}

          {showAbaAprovadoParaPagamento && (
            <Tab
              eventKey="aprovado"
              title="Aprovados para pagamento"
              style={{
                color: "black",
              }}
            >
              <TabAprovadosParaPagamento aba={aba} />
            </Tab>
          )}

          {showAbaReprovados && (
            <Tab
              eventKey="reprovados"
              title="Reprovados"
              style={{ color: "black" }}
            >
              <TabReprovados aba={aba} />
            </Tab>
          )}
        </CustomTabs>
      )}

      <ModalCriarLote
        show={showModalCriarLote}
        handleClose={handleCloseModalCriarLote}
        onSubmit={onSubmitModalCriarLote}
      />
    </Container>
  );
}
